import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { EstruturaRetornoOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno.output.dto";
import { pesquisarJornalPaginado, pesquisarJornalPaginadoCatchError, pesquisarJornalPaginadoFailure, pesquisarJornalPaginadoSuccess } from "../../actions/Pesquisa/pesquisar-jornal-paginado.action";
import { PesquisaService } from "src/app/services/pesquisa.service";

@Injectable()
export class PesquisarJornalPaginadoEffects {

  public PesquisarJornalPaginado$: unknown;

  constructor(private actions$: Actions,
    private pesquisaService: PesquisaService) {
    this.createEffects()
  }

  private createEffects() {
    this.PesquisarJornalPaginado$ = createEffect(() => this.actions$.pipe(
      ofType(pesquisarJornalPaginado),
      switchMap(({ inputDto }) =>
        this.pesquisaService
          .PesquisarJornaisPaginados(inputDto)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return pesquisarJornalPaginadoFailure({ response })
                }
                return pesquisarJornalPaginadoSuccess({ response })
              }),
             catchError((error: HttpErrorResponse) => {
                const e = new EstruturaRetornoOutputDto(Object.values(error?.error?.erros))
                return of( pesquisarJornalPaginadoCatchError({response: e}))
              }
            )
          )
      )
    )
    );
  }
}
